import store from '@/store';

export default class SuccessComponent {
	public get campaignStartDate(): string | null {
		return store.getters.campaignStartDate();
	}
}
